import React from 'react';
import Icon from '../../../components/AppIcon';


const QuickActions = () => {
  const quickActions = [
    {
      id: 'new-article',
      title: 'مقال جديد',
      description: 'إنشاء مقال أو إعلان جديد',
      icon: 'FileText',
      path: '/article-editor',
      color: 'primary',
      featured: true
    },
    {
      id: 'new-sub-union',
      title: 'اتحاد فرعي جديد',
      description: 'إضافة اتحاد فرعي جديد',
      icon: 'Building2',
      path: '/sub-union-form',
      color: 'secondary',
      featured: true
    },
    {
      id: 'new-project',
      title: 'مشروع جديد',
      description: 'بدء مشروع جديد',
      icon: 'FolderPlus',
      path: '/project-form',
      color: 'success',
      featured: false
    },
    {
      id: 'new-office',
      title: 'منصب جديد',
      description: 'إضافة منصب إداري',
      icon: 'Briefcase',
      path: '/office-form',
      color: 'warning',
      featured: false
    },
    {
      id: 'manage-cities',
      title: 'إدارة المدن',
      description: 'تحديث بيانات المدن',
      icon: 'MapPin',
      path: '/cities-management',
      color: 'primary',
      featured: false
    },
    {
      id: 'view-reports',
      title: 'التقارير',
      description: 'عرض التقارير والإحصائيات',
      icon: 'BarChart3',
      path: '/reports',
      color: 'accent',
      featured: false
    }
  ];

  const handleNavigation = (path) => {
    window.location.href = path;
  };

  const getColorClasses = (color, featured = false) => {
    const baseClasses = featured ? 'border-2' : 'border';
    
    switch (color) {
      case 'success':
        return `${baseClasses} border-success/20 bg-success/5 hover:bg-success/10`;
      case 'warning':
        return `${baseClasses} border-warning/20 bg-warning/5 hover:bg-warning/10`;
      case 'error':
        return `${baseClasses} border-error/20 bg-error/5 hover:bg-error/10`;
      case 'secondary':
        return `${baseClasses} border-secondary/20 bg-secondary/5 hover:bg-secondary/10`;
      case 'accent':
        return `${baseClasses} border-accent/20 bg-accent/5 hover:bg-accent/10`;
      default:
        return `${baseClasses} border-primary/20 bg-primary/5 hover:bg-primary/10`;
    }
  };

  const getIconColor = (color) => {
    switch (color) {
      case 'success':
        return 'text-success';
      case 'warning':
        return 'text-warning';
      case 'error':
        return 'text-error';
      case 'secondary':
        return 'text-secondary';
      case 'accent':
        return 'text-accent';
      default:
        return 'text-primary';
    }
  };

  const featuredActions = quickActions?.filter(action => action?.featured);
  const regularActions = quickActions?.filter(action => !action?.featured);

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation-1">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-foreground font-arabic">الإجراءات السريعة</h2>
          <Icon name="Zap" size={20} className="text-muted-foreground" />
        </div>
      </div>
      <div className="p-6">
        {/* Featured Actions */}
        <div className="space-y-4 mb-6">
          {featuredActions?.map((action) => (
            <button
              key={action?.id}
              onClick={() => handleNavigation(action?.path)}
              className={`w-full p-4 rounded-lg transition-all duration-200 text-right rtl:text-right ${getColorClasses(action?.color, true)} hover:shadow-elevation-1`}
            >
              <div className="flex items-center space-x-4 rtl:space-x-reverse">
                <div className={`w-12 h-12 rounded-lg bg-card border border-border flex items-center justify-center ${getIconColor(action?.color)}`}>
                  <Icon name={action?.icon} size={24} />
                </div>
                <div className="flex-1 text-right rtl:text-right">
                  <h3 className="text-base font-semibold text-foreground mb-1 font-arabic">
                    {action?.title}
                  </h3>
                  <p className="text-sm text-muted-foreground font-caption">
                    {action?.description}
                  </p>
                </div>
                <Icon name="ArrowLeft" size={16} className="text-muted-foreground rtl:rotate-180" />
              </div>
            </button>
          ))}
        </div>

        {/* Regular Actions Grid */}
        <div className="grid grid-cols-2 gap-3">
          {regularActions?.map((action) => (
            <button
              key={action?.id}
              onClick={() => handleNavigation(action?.path)}
              className={`p-3 rounded-lg transition-all duration-200 text-center ${getColorClasses(action?.color)} hover:shadow-elevation-1`}
            >
              <div className={`w-8 h-8 rounded-lg bg-card border border-border flex items-center justify-center mx-auto mb-2 ${getIconColor(action?.color)}`}>
                <Icon name={action?.icon} size={16} />
              </div>
              <h4 className="text-sm font-medium text-foreground mb-1 font-arabic">
                {action?.title}
              </h4>
              <p className="text-xs text-muted-foreground font-caption">
                {action?.description}
              </p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickActions;